<template>
  <SfCardInline v-if="isValid" data-testid="hyperlink-card">
    <template #left>
      <SfLink
        class="!tw-no-underline"
        :href="safeLink"
        :disabled="!safeLink"
        target="_blank"
      >
        <div class="tw-flex tw-items-center">
          <SfEllipsis :length="250" :tooltip="name">{{ name }}</SfEllipsis>
        </div>
        <i class="fa-solid fa-arrow-up-right-from-square tw-text-[10px]"></i>
      </SfLink>
    </template>
    <template #right>
      <InlineActionConfirmation @confirm="handleDelete">
        <template #default="{ openConfirmation }">
          <div class="tw-flex tw-gap-[2px]">
            <SfButtonIcon
              v-if="allowEdit"
              :icon="'pencil'"
              :seamless="true"
              :small="true"
              data-testid="document-pill-view"
              @click="handleEdit"
            ></SfButtonIcon>
            <SfButtonIcon
              v-if="allowDelete"
              class="hover:tw-text-sf-danger-light-1"
              :icon="'trash'"
              :seamless="true"
              :small="true"
              data-testid="document-pill-delete"
              @click="openConfirmation"
            />
          </div>
        </template>
      </InlineActionConfirmation>
    </template>
  </SfCardInline>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import InlineActionConfirmation from '@app/shared/vue/components/molecules/inline-action-confirmation/inline-action-confirmation.vue'
import SfCardInline from '@app/shared/vue/components/sf-card/sf-card-inline.vue'
import SfEllipsis from '@app/shared/vue/components/sf-ellipsis/sf-ellipsis.vue'
import SfLink from '@app/shared/vue/components/sf-link.vue'
import { SfButtonIcon } from '@silverfin/ui-components'
import { isLinkWithSfAllowedProtocol } from '@app/utils/url-helpers'

interface Props {
  allowDelete?: boolean
  allowEdit?: boolean
  id?: number
  name: string
  link: string
}

const { id, name = '', link = '' } = defineProps<Props>()

const emit =
  defineEmits<{
    delete: []
    edit: [id: number]
  }>()

const isValid = computed(() => {
  return name && link
})

const safeLink = computed(() => {
  return isLinkWithSfAllowedProtocol(link) ? link : ''
})

function handleDelete() {
  emit('delete')
}

function handleEdit() {
  if (id) {
    emit('edit', id)
  }
}
</script>
